var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.userInfo != null)?_c('div',{staticStyle:{"height":"100%"}},[_c('router-view',{attrs:{"user-info":this.userInfo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }